module.exports = __webpack_public_path__ + "img/CAF.1d240331.svg";